module.exports = "/images/Cosmic Golf.svg?ae32343b90ce5f3e005e66b05293f65d";